import { render, staticRenderFns } from "./contractInfo.vue?vue&type=template&id=df615bba&scoped=true"
import script from "./contractInfo.vue?vue&type=script&lang=js"
export * from "./contractInfo.vue?vue&type=script&lang=js"
import style0 from "./contractInfo.vue?vue&type=style&index=0&id=df615bba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df615bba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('df615bba')) {
      api.createRecord('df615bba', component.options)
    } else {
      api.reload('df615bba', component.options)
    }
    module.hot.accept("./contractInfo.vue?vue&type=template&id=df615bba&scoped=true", function () {
      api.rerender('df615bba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/contract/components/contractInfo.vue"
export default component.exports